import { EShop } from '@containers/App/model';
import { useApolloClientHeaders } from '@hooks/useApolloClientHeaders';

import { useIsDualPrice } from '../hooks/useIsDualPrice';

import { GetVariantOfferArgs, getVariantOffers } from './utils';

export const useVariantOffers = ({
  product,
  imageDomainPath,
  itemCountry,
  formatMessage,
}: Omit<GetVariantOfferArgs, 'variant'>) => {
  const { isDualPrice, getLeftSideFormattedPrice } = useIsDualPrice();
  const isBulgaria = useApolloClientHeaders().shopId === EShop.NOTINO_BG;

  const shouldAddDualCurrencyOffer = isBulgaria && isDualPrice;

  return getVariantOffers({
    product,
    imageDomainPath,
    itemCountry,
    formatMessage,
    isBulgaria,
    ...(shouldAddDualCurrencyOffer &&
      getLeftSideFormattedPrice && {
        convertToEur: getLeftSideFormattedPrice,
      }),
  });
};
